import React from 'react';
import { ITranslateProps, translate } from '../../mixins/translate';
import { PanelTopHeading } from '../elements';
import ChangePersonalData from './ChangePersonalData';

class ProfileComponent extends React.Component<ITranslateProps, Record<string, unknown>> {
    public override render() {
        return (
            <section id="content" className="table-layout animated fadeIn">
                <div className="tray tray-center">
                    <div className="admin-form theme-primary mw700 center-block" style={{ paddingBottom: '175px' }}>
                        <div className="panel heading-border">
                            <PanelTopHeading>{this.props.t('common.profile')}</PanelTopHeading>
                            <ChangePersonalData />
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const Profile = translate()(ProfileComponent);
export { Profile };
